var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashcanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.22 7.25977L16.54 18.0598C16.54 19.4198 15.43 20.5398 14.07 20.5398H6.86997C5.50997 20.5398 4.39997 19.4198 4.39997 18.0598L3.71997 7.25977H17.24H17.22Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.13 4.96961C13.13 3.49961 11.94 2.29961 10.47 2.29961C8.99999 2.29961 7.80999 3.49961 7.80999 4.96961H5.87C5.87 2.41961 7.92999 0.349609 10.47 0.349609C13.01 0.349609 15.07 2.41961 15.07 4.96961H13.13Z",
    fill: "#AFAFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.73 5.89914H1.2C0.709997 5.89914 0.309998 5.49914 0.309998 5.00914C0.309998 4.51914 0.709997 4.11914 1.2 4.11914H19.73C20.22 4.11914 20.62 4.51914 20.62 5.00914C20.62 5.49914 20.22 5.89914 19.73 5.89914Z",
    fill: "#AFAFAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanIcon);
export default __webpack_public_path__ + "static/media/trashcan_icon.59150a020bd5e21f1c88d68d37408f85.svg";
export { ForwardRef as ReactComponent };